import { InternalAxiosRequestConfig } from 'axios';
import Keycloak from 'keycloak-js';

import { forceCSRFToken, forceJsonHeaders } from 'v2/interceptors';
import { runInsideLock } from 'v2/concurrent';

import { authStorage } from './storages';
import { isAccessTokenExpires } from './utils';

function forceAuthenticationHeader(config: InternalAxiosRequestConfig) {
  const authParams = authStorage.getJwtAuthParams();
  if (authParams?.token) {
    config.headers.Authorization = `Bearer ${authParams.token}`;
  }
}

export function requestInterceptor(config: InternalAxiosRequestConfig) {
  forceJsonHeaders(config);
  forceAuthenticationHeader(config);
  forceCSRFToken(config);

  return config;
}

export function createResponseInterceptor(service: Keycloak, allowAnonymous: boolean) {
  let refreshPromise: Promise<void> | undefined = undefined;

  const runRefreshProcess = async () => {
    const keycloakTokens = authStorage.getJwtAuthParams();

    if (keycloakTokens?.token && !isAccessTokenExpires(keycloakTokens.token)) {
      refreshPromise = undefined;

      return;
    }

    if (keycloakTokens?.refreshToken) {
      try {
        await service.updateToken(5);
        await authStorage.setJwtAuthParams({
          token: service.token,
          refreshToken: service.refreshToken,
          idToken: service.idToken,
        });
        refreshPromise = undefined;

        return;
      } catch {
        await service.login();
      }
    }

    refreshPromise = undefined;
    if (allowAnonymous) return Promise.reject();
  };

  return () => {
    if (refreshPromise) return refreshPromise;

    refreshPromise = runInsideLock(runRefreshProcess);

    return refreshPromise;
  };
}
